module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<footer class="container">\r\n  <div class="layout">\r\n    <div class="footer">\r\n      <a href="index.html" class="left-logo">\r\n        <img src="' +
((__t = (require('../../assets/images/logo.png'))) == null ? '' : __t) +
'" alt="">\r\n      </a>\r\n      <div class="right-nav">\r\n        <a href="#">Home</a>\r\n        <a href="#">About Us</a>\r\n        <a href="#">Become a Dealer</a>\r\n        <a href="#">Tire Registration</a>\r\n        <a href="#">Contact</a>\r\n      </div>\r\n    </div>\r\n    <div class="copyright">\r\n      Copyright © <script language="JavaScript">var today = new Date();document.write(today.getFullYear())</script> \r\n      <a href="/" >Transamerica</a> All Rights Reserved\r\n    </div>\r\n  </div>\r\n</footer>';

}
return __p
}